/**
 * 图谱图例组件
 * 从 MemoryService 迁移，适配 Axiom 架构
 */

// 实体类型配置
const ENTITY_TYPES = [
  { type: 'Person', label: '人物', color: '#007AFF' },
  { type: 'Family', label: '家人', color: '#FF2D55' },
  { type: 'Friend', label: '朋友', color: '#34C759' },
  { type: 'City', label: '城市', color: '#5AC8FA' },
  { type: 'Hobby', label: '爱好', color: '#AF52DE' },
  { type: 'Food', label: '食物', color: '#FF9500' },
  { type: 'Pet', label: '宠物', color: '#FFCC00' },
  { type: 'Event', label: '事件', color: '#5856D6' },
  { type: 'Other', label: '其他', color: '#8E8E93' },
]

// 置信度图例
const CONFIDENCE_LEVELS = [
  { level: 'high', label: '高置信度', opacity: 1, style: 'solid' },
  { level: 'medium', label: '中置信度', opacity: 0.7, style: 'dashed' },
  { level: 'low', label: '低置信度', opacity: 0.4, style: 'dotted' },
]

interface GraphLegendProps {
  collapsed?: boolean
}

export default function GraphLegend({ collapsed = false }: GraphLegendProps) {
  if (collapsed) {
    return (
      <div className="absolute bottom-4 left-4 px-3 py-1.5 rounded-lg text-xs bg-slate-900/CC text-slate-400 backdrop-blur-sm">
        💡 双击空白处重置视角
      </div>
    )
  }
  
  return (
    <div className="absolute bottom-4 left-4 p-3 rounded-xl bg-slate-900/E6 backdrop-blur-sm border border-slate-800">
      {/* 实体类型图例 */}
      <div className="mb-3">
        <h4 className="text-xs font-medium mb-2 text-slate-400">
          实体类型
        </h4>
        <div className="flex flex-wrap gap-2">
          {ENTITY_TYPES.map(({ type, label, color }) => (
            <div key={type} className="flex items-center gap-1">
              <div 
                className="w-3 h-3 rounded-full"
                style={{ background: color }}
              />
              <span className="text-xs text-slate-500">
                {label}
              </span>
            </div>
          ))}
        </div>
      </div>
      
      {/* 置信度图例 */}
      <div>
        <h4 className="text-xs font-medium mb-2 text-slate-400">
          置信度
        </h4>
        <div className="flex gap-3">
          {CONFIDENCE_LEVELS.map(({ level, label, opacity }) => (
            <div key={level} className="flex items-center gap-1">
              <div 
                className="w-4 h-4 rounded-full border-2"
                style={{ 
                  background: `rgba(0, 122, 255, ${opacity})`,
                  borderColor: `rgba(255, 255, 255, ${opacity * 0.5})`,
                  boxShadow: level === 'high' ? '0 0 8px rgba(0, 122, 255, 0.5)' : 'none',
                }}
              />
              <span className="text-xs text-slate-500">
                {label}
              </span>
            </div>
          ))}
        </div>
      </div>
      
      {/* 操作提示 */}
      <div className="mt-3 pt-2 border-t border-slate-800">
        <p className="text-xs text-slate-500">
          💡 拖拽节点 | 滚轮缩放 | 双击重置
        </p>
      </div>
    </div>
  )
}

